//210310
//A basic pivot table function, probably could use more work

export default {

  install (Vue, options) {
    
    const pivotFunctions = {
      count: function(a,b){
        a = a === undefined ? 0 : a;
        b = b === undefined ? 0 : 1;
        return parseInt(a) + parseInt(b);
      },
      sum: function(a,b){
        a = a === undefined ? 0 : a;
        return parseFloat(a) + parseFloat(b);
      },
    }

    const pivot = {
      pivot(data, rowKeys, colKeys, functions){
        let result = {}
        data.forEach(row =>{
          rowKeys.forEach(rowKey => {
            result[row[rowKey]] = result[row[rowKey]] === undefined ? {} : result[row[rowKey]];
      
            colKeys.forEach(colKey => {
      
              functions.forEach(f=>{
                const r = result[row[rowKey]]
                const funcName = f[0];
                const funcKey = f[1];
                const displayName = f[2] === undefined ? funcKey : f[2];
                const func = pivotFunctions[funcName]
                r[row[colKey]] = r[row[colKey]] === undefined ? {} : r[row[colKey]]
                r[row[colKey]][displayName] = func(r[row[colKey]][displayName],  row[funcKey])
              })
            })
      
      
          })
        })
      
        //Add rows and col arrays
        result = {data:result}
        result.rows = Object.keys(result.data);
        result.columns = {}
        result.rows.forEach(row=>{
          result.columns = {...result.columns, ...result.data[row]}
        })
        result.rowKeys = rowKeys
        // result.subcolumns = 
        // result.columns = Object.keys(result.columns).sort()
      
        return result;
      },

      // toArray
      // 
      toArray(obj, order=[], emptyValue=0){
        const result = [];
  
        //Reorder the Columns
        const orderedColumns = [];
        order.forEach(key=>Object.keys(obj.columns).includes(key) ? orderedColumns.push(key) : 1+1)
        Object.keys(obj.columns).forEach(key=>!orderedColumns.includes(key) ? orderedColumns.push(key) : 1+1)
  
        obj.rows.forEach(row=>{
          const dataRow = {}
          //Currently hardcoded one row key
          dataRow[obj.rowKeys[0]] = row
          orderedColumns.forEach(column =>{
            Object.keys(obj.columns[column]).forEach(subColumn => {
              dataRow[`${column}_${subColumn}`] = obj.data[row][column] ? obj.data[row][column][subColumn] : emptyValue
            })
          })
          // console.log(new Date(), dataRow)
          result.push(dataRow)
  
        })
        // console.log(result)
        return result
      },

      toObj(obj, order=[], emptyValue=0){
        return this.toArray(obj, order, emptyValue)[0]
      },
      
      toRow(obj, order=[], emptyValue=0){
        return this.toArray(obj, order, emptyValue)[0]
      },

      // Creates an array, like a csv array
      // Probably needs to be reworked
      toTableArray(obj, order=[], emptyValue=0){
        const result = [];
        const row1 = []
        row1.push('date')
        // const orderedColumns = [...order, ...Object.keys(obj.columns)]

        //Reorder the Columns
        const orderedColumns = [];
        order.forEach(key=>Object.keys(obj.columns).includes(key) ? orderedColumns.push(key) : 1+1)
        Object.keys(obj.columns).forEach(key=>!orderedColumns.includes(key) ? orderedColumns.push(key) : 1+1)
        // console.log(order, orderedColumns)
        
        orderedColumns.forEach(column =>{
          row1.push(column)
          Object.keys(obj.columns[column]).forEach(subColumn => row1.push(''))
          row1.pop()
        })
        result.push(row1)

        const row2 = []
        row2.push('')
        orderedColumns.forEach(column =>{
          
          Object.keys(obj.columns[column]).forEach(subColumn => row2.push(subColumn))
        })
        result.push(row2)

        obj.rows.forEach(row=>{
          const dataRow2 = []
          dataRow2.push(row)
          // Object.keys(obj.data[row]).forEach(column =>{
          orderedColumns.forEach(column =>{
            // dataRow2.push('')
            Object.keys(obj.columns[column]).forEach(subColumn => {
              // console.log(column, subColumn)
              dataRow2.push(obj.data[row][column] ? obj.data[row][column][subColumn] : emptyValue)
            })
          })
          result.push(dataRow2)

        })
        // console.log(result)
        return result
      },


    }

    Vue.prototype.$pivot = pivot
    

  }
}